import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { MainAuthComponent } from './pages/main-auth/main-auth.component';
import { NewLoginComponent } from './pages/new-login/new-login.component';

const routes: Routes = [
	{
		path: '',
		component: MainAuthComponent,
		children: [
			{ path: 'new-login', component: NewLoginComponent },
			{ path: 'forgot-password', component: ForgotPasswordComponent },
			{ path: '**', redirectTo: 'new-login' },
		],
	},
	// {
	//   path:'',
	//   component:MainSignUpComponent,
	//   children: [
	//     { path:'forgot-password', component:ForgotPasswordComponent },
	//     { path:'**', redirectTo:'forgot-password'}
	//   ]
	// }
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AuthRoutingModule {}
